<template>
    <div>
        <div v-if="loading" class="flex justify-center items-center min-h-[200px]">
      <div class="animate-spin rounded-full h-12 w-12 border-b-2 border-custom-yellow"></div>
    </div> 
    <template v-else>
        <div class="relative overflow-x-auto shadow-md sm:rounded-lg mt-5">
            <table class="w-full text-left rtl:text-right text-gray-700">
                <thead>
                    <tr class="bg-gray-100">
                        <th scope="col" class="p-4">
                            <div class="flex items-center">
                                <input id="checkbox-all-search" type="checkbox"
                                    class="w-4 h-4 text-custom-yellow bg-gray-100 border-gray-300 rounded focus:ring-custom-yellow dark:focus:ring-custom-yellow dark:ring-offset-gray-800 dark:focus:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600">
                                <label for="checkbox-all-search" class="sr-only">checkbox</label>
                            </div>
                        </th>
                        <th scope="col" class="px-6">
                            <div class="flex items-center">
                                Serial no.
                                <a href="#"><svg class="w-3 h-3 ms-1.5" aria-hidden="true"
                                        xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24">
                                        <path
                                            d="M8.574 11.024h6.852a2.075 2.075 0 0 0 1.847-1.086 1.9 1.9 0 0 0-.11-1.986L13.736 2.9a2.122 2.122 0 0 0-3.472 0L6.837 7.952a1.9 1.9 0 0 0-.11 1.986 2.074 2.074 0 0 0 1.847 1.086Zm6.852 1.952H8.574a2.072 2.072 0 0 0-1.847 1.087 1.9 1.9 0 0 0 .11 1.985l3.426 5.05a2.123 2.123 0 0 0 3.472 0l3.427-5.05a1.9 1.9 0 0 0 .11-1.985 2.074 2.074 0 0 0-1.846-1.087Z" />
                                    </svg></a>
                            </div>
                        </th>
                        <th scope="col" class="px-6">
                            <div class="flex items-center">
                                Unit Product
                                <a href="#"><svg class="w-3 h-3 ms-1.5" aria-hidden="true"
                                        xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24">
                                        <path
                                            d="M8.574 11.024h6.852a2.075 2.075 0 0 0 1.847-1.086 1.9 1.9 0 0 0-.11-1.986L13.736 2.9a2.122 2.122 0 0 0-3.472 0L6.837 7.952a1.9 1.9 0 0 0-.11 1.986 2.074 2.074 0 0 0 1.847 1.086Zm6.852 1.952H8.574a2.072 2.072 0 0 0-1.847 1.087 1.9 1.9 0 0 0 .11 1.985l3.426 5.05a2.123 2.123 0 0 0 3.472 0l3.427-5.05a1.9 1.9 0 0 0 .11-1.985 2.074 2.074 0 0 0-1.846-1.087Z" />
                                    </svg></a>
                            </div>
                        </th>
                        <th scope="col" class="px-6">
                            <div class="flex items-center">
                                Blood Group
                                <a href="#"><svg class="w-3 h-3 ms-1.5" aria-hidden="true"
                                        xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24">
                                        <path
                                            d="M8.574 11.024h6.852a2.075 2.075 0 0 0 1.847-1.086 1.9 1.9 0 0 0-.11-1.986L13.736 2.9a2.122 2.122 0 0 0-3.472 0L6.837 7.952a1.9 1.9 0 0 0-.11 1.986 2.074 2.074 0 0 0 1.847 1.086Zm6.852 1.952H8.574a2.072 2.072 0 0 0-1.847 1.087 1.9 1.9 0 0 0 .11 1.985l3.426 5.05a2.123 2.123 0 0 0 3.472 0l3.427-5.05a1.9 1.9 0 0 0 .11-1.985 2.074 2.074 0 0 0-1.846-1.087Z" />
                                    </svg></a>
                            </div>
                        </th>
                        <th scope="col" class="px-6">
                            <div class="flex items-center">
                                Volume
                                <a href="#"><svg class="w-3 h-3 ms-1.5" aria-hidden="true"
                                        xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24">
                                        <path
                                            d="M8.574 11.024h6.852a2.075 2.075 0 0 0 1.847-1.086 1.9 1.9 0 0 0-.11-1.986L13.736 2.9a2.122 2.122 0 0 0-3.472 0L6.837 7.952a1.9 1.9 0 0 0-.11 1.986 2.074 2.074 0 0 0 1.847 1.086Zm6.852 1.952H8.574a2.072 2.072 0 0 0-1.847 1.087 1.9 1.9 0 0 0 .11 1.985l3.426 5.05a2.123 2.123 0 0 0 3.472 0l3.427-5.05a1.9 1.9 0 0 0 .11-1.985 2.074 2.074 0 0 0-1.846-1.087Z" />
                                    </svg></a>
                            </div>
                        </th>
                        <th scope="col" class="px-6">
                            <div class="flex items-center">
                                Blood Origin
                                <a href="#"><svg class="w-3 h-3 ms-1.5" aria-hidden="true"
                                        xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24">
                                        <path
                                            d="M8.574 11.024h6.852a2.075 2.075 0 0 0 1.847-1.086 1.9 1.9 0 0 0-.11-1.986L13.736 2.9a2.122 2.122 0 0 0-3.472 0L6.837 7.952a1.9 1.9 0 0 0-.11 1.986 2.074 2.074 0 0 0 1.847 1.086Zm6.852 1.952H8.574a2.072 2.072 0 0 0-1.847 1.087 1.9 1.9 0 0 0 .11 1.985l3.426 5.05a2.123 2.123 0 0 0 3.472 0l3.427-5.05a1.9 1.9 0 0 0 .11-1.985 2.074 2.074 0 0 0-1.846-1.087Z" />
                                    </svg></a>
                            </div>
                        </th>
                        <th scope="col" class="px-6">
                            <div class="flex items-center">
                                Date Added
                                <a href="#"><svg class="w-3 h-3 ms-1.5" aria-hidden="true"
                                        xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24">
                                        <path
                                            d="M8.574 11.024h6.852a2.075 2.075 0 0 0 1.847-1.086 1.9 1.9 0 0 0-.11-1.986L13.736 2.9a2.122 2.122 0 0 0-3.472 0L6.837 7.952a1.9 1.9 0 0 0-.11 1.986 2.074 2.074 0 0 0 1.847 1.086Zm6.852 1.952H8.574a2.072 2.072 0 0 0-1.847 1.087 1.9 1.9 0 0 0 .11 1.985l3.426 5.05a2.123 2.123 0 0 0 3.472 0l3.427-5.05a1.9 1.9 0 0 0 .11-1.985 2.074 2.074 0 0 0-1.846-1.087Z" />
                                    </svg></a>
                            </div>
                        </th>
                        <th scope="col" class="px-6">
                            <div class="flex items-center">
                                Expiry Date
                                <a href="#"><svg class="w-3 h-3 ms-1.5" aria-hidden="true"
                                        xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24">
                                        <path
                                            d="M8.574 11.024h6.852a2.075 2.075 0 0 0 1.847-1.086 1.9 1.9 0 0 0-.11-1.986L13.736 2.9a2.122 2.122 0 0 0-3.472 0L6.837 7.952a1.9 1.9 0 0 0-.11 1.986 2.074 2.074 0 0 0 1.847 1.086Zm6.852 1.952H8.574a2.072 2.072 0 0 0-1.847 1.087 1.9 1.9 0 0 0 .11 1.985l3.426 5.05a2.123 2.123 0 0 0 3.472 0l3.427-5.05a1.9 1.9 0 0 0 .11-1.985 2.074 2.074 0 0 0-1.846-1.087Z" />
                                    </svg></a>
                            </div>
                        </th>
                        <th scope="col" class="px-6">
                            <div class="flex items-center">
                                Approved By
                                <a href="#"><svg class="w-3 h-3 ms-1.5" aria-hidden="true"
                                        xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24">
                                        <path
                                            d="M8.574 11.024h6.852a2.075 2.075 0 0 0 1.847-1.086 1.9 1.9 0 0 0-.11-1.986L13.736 2.9a2.122 2.122 0 0 0-3.472 0L6.837 7.952a1.9 1.9 0 0 0-.11 1.986 2.074 2.074 0 0 0 1.847 1.086Zm6.852 1.952H8.574a2.072 2.072 0 0 0-1.847 1.087 1.9 1.9 0 0 0 .11 1.985l3.426 5.05a2.123 2.123 0 0 0 3.472 0l3.427-5.05a1.9 1.9 0 0 0 .11-1.985 2.074 2.074 0 0 0-1.846-1.087Z" />
                                    </svg></a>
                            </div>
                        </th>
                        <th scope="col" class="px-6">
                            <div class="flex items-center">
                                Status
                                <a href="#"><svg class="w-3 h-3 ms-1.5" aria-hidden="true"
                                        xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24">
                                        <path
                                            d="M8.574 11.024h6.852a2.075 2.075 0 0 0 1.847-1.086 1.9 1.9 0 0 0-.11-1.986L13.736 2.9a2.122 2.122 0 0 0-3.472 0L6.837 7.952a1.9 1.9 0 0 0-.11 1.986 2.074 2.074 0 0 0 1.847 1.086Zm6.852 1.952H8.574a2.072 2.072 0 0 0-1.847 1.087 1.9 1.9 0 0 0 .11 1.985l3.426 5.05a2.123 2.123 0 0 0 3.472 0l3.427-5.05a1.9 1.9 0 0 0 .11-1.985 2.074 2.074 0 0 0-1.846-1.087Z" />
                                    </svg></a>
                            </div>
                        </th>
                        <th scope="col" class="px-6">
                            Action
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(external_screening, index) in filteredScreenings" :key="external_screening.external_screening_id" class="border-b">
                        <td class="w-4 p-4">
                            <div class="flex items-center">
                                <input :id="'checkbox-table-search-' + index" type="checkbox" class="w-4 h-4">
                                <label :for="'checkbox-table-search-' + index" class="sr-only">checkbox</label>
                            </div>
                        </td>
                        <td class="px-6 py-2">{{ external_screening.pint_serial }}</td>
                        <td class="px-6 py-2">{{ external_screening.unit_product?.name ?? 'N/A'}}
                        </td> 
                        <td class="px-6 py-2">{{ external_screening.blood_group?.description ?? 'Unknown' }}</td>
                        <td class="px-6 py-2">{{ external_screening.volume }} ml</td>
                        <td class="px-6 py-2">{{ external_screening.origin }} </td>
                        <td class="px-6 py-2">{{ new Date(external_screening.created_at).toLocaleDateString('en-CA') }} </td>
                        <td class="px-6 py-2">{{ external_screening.expiry_date }} </td>
                        <td class="px-6 py-2">{{ external_screening.approved_by?.first_name ?? '' }} {{ external_screening.approved_by?.last_name ?? ''}} </td>
                        <td class="px-6 py-2">
                            
                            <span class="px-2 py-1 rounded" :class="{
                                'text-red-500 bg-red-100': ['Unscreened', 'Disposed', 'Pending Disposal'].includes(getExtenalScreeningStatus(external_screening)),
                                'text-green-500 bg-green-100': ['Pending Approval', 'ongoing screening'].includes(getExtenalScreeningStatus(external_screening)),
                                'text-orange-500 bg-orange-100': ['Approved', 'Split', 'Requote', 'Leuco-reduction'].includes(getExtenalScreeningStatus(external_screening))
                            }">
                                {{ getExtenalScreeningStatus(external_screening) }}
                            </span>
                        </td>
                        <td class="flex items-center px-6 py-2">
                            <template
                                v-if="getExtenalScreeningStatus(external_screening) === 'ongoing screening'">
                                <CustomButton label="Screen" @click="handleScreen(external_screening.external_screening_id)"
                                    bg-class="bg-custom-yellow text-sm py-2" />
                            </template>
                            <template v-if="getExtenalScreeningStatus(external_screening) === 'Pending Approval'">
                                <CustomButton label="Approve" @click="handleApprove(external_screening.external_screening_id)"
                                    bg-class="bg-custom-yellow text-sm py-2" />
                            </template>
                            <template v-if="getExtenalScreeningStatus(external_screening) === 'Pending Disposal'">
                                <CustomButton label="Dispose" @click="handleDispose(external_screening.external_screening_id)"
                                    bg-class="bg-red-400 text-sm py-2" />
                            </template>
                            <template
                                v-if="getExtenalScreeningStatus(external_screening) === 'Approved' || getExtenalScreeningStatus(external_screening) === 'Disposed' || getExtenalScreeningStatus(external_screening) === 'Split' || getExtenalScreeningStatus(external_screening) === 'Requote' || getExtenalScreeningStatus(external_screening) === 'Leuco-reduction'">
                                <CustomButton label="View Details"
                                    @click="handleViewDetails(external_screening.external_screening_id)"
                                    :disabled="isLoading[external_screening.external_screeningn_id]" 
                                    :bg-class="isLoading[external_screening.external_screening_id] ? 'bg-gray-300 cursor-not-allowed' : 'bg-custom-yellow text-sm py-1'"   />
                            </template>
                            <div v-if="isLoading[external_screening.external_screening_id]" class="ml-2 animate-spin rounded-full h-5 w-5 border-t-2 border-b-2 border-gray-900"></div>

                        </td>

                    </tr>
                </tbody>
            </table>
        </div>
        <p class="text-center text-gray-600 mb-2">{{ showingText }}</p>
        <div class="flex justify-center gap-4 mt-4">
            <button @click="previousPage" :disabled="currentPage === 1"
                class="flex items-center gap-2 px-6 py-3 font-bold text-center text-custom-blue align-middle transition-all rounded-lg select-none hover:bg-custom-blue/10 active:bg-custom-blue/20 disabled:pointer-events-none disabled:opacity-50 disabled:shadow-none"
                type="button">
                <svg class="w-6 h-6" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                    fill="none" viewBox="0 0 24 24">
                    <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="m15 19-7-7 7-7" />
                </svg>
                Previous
            </button>

            <div class="flex items-center gap-2">
                <button v-for="page in visiblePages" :key="page" @click="goToPage(page)" :class="{
                    'bg-custom-blue text-white': page === currentPage,
                    'text-custom-blue': page !== currentPage
                }" class="relative h-10 max-h-[40px] w-10 max-w-[40px] select-none rounded-lg text-center align-middle font-medium transition-all hover:bg-custom-blue/10 active:bg-custom-blue/20 disabled:pointer-events-none disabled:opacity-50 disabled:shadow-none"
                    type="button">
                    <span class="absolute transform -translate-x-1/2 -translate-y-1/2 top-1/2 left-1/2">
                        {{ page }}
                    </span>
                </button>
            </div> 

            <button @click="nextPage" :disabled="currentPage === totalPages"
                class="flex items-center gap-2 px-6 py-3 font-bold text-center text-custom-blue align-middle transition-all rounded-lg select-none hover:bg-custom-blue/10 active:bg-custom-blue/20 disabled:pointer-events-none disabled:opacity-50 disabled:shadow-none"
                type="button">
                Next
                <svg class="w-6 h-6" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                    fill="none" viewBox="0 0 24 24">
                    <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="m9 5 7 7-7 7" />
                </svg>
            </button>
        </div>
    </template>
    </div>
</template>

<script>
import CustomButton from '@/components/CustomButton.vue';
import api from '@/services/api';
import SweetAlertService from '@/services/SweetAlertService';

export default {
    name: 'ExternalUnitsTab',
    components: {
        CustomButton,
    },

    props: {
        searchQuery: {
            type: String,
            default: ''
        }
    },

    data() {
        return {
            currentPage: 1,
            totalPages: 0,
            totalCount: 0,
            perPage: 10,
            loading: false,
            external_screenings: [],
            isLoading: {},
            error: null,
            filters: {
                bloodGroup: "",
                dateRegistered: '',
                status: '',
            },
        }
    },

    created() {
        this.getexternalunits();
    },

    computed: {
        visiblePages() {
            return this.calculatePageRange();
        },
        filteredScreenings() {
            console.log('Filtered Screenings:', this.external_screenings); 
            const search = this.searchQuery.toLowerCase();

            return this.external_screenings.filter(external_screening => {
                const pintSerial = external_screening.pint_serial || '';
                const bloodGroupDescription = external_screening.blood_group_id?.description || '';
                const volume = external_screening.volume?.toString() || '';
                const dateAdded = external_screening.created_at || '';
                const origin = external_screening.origin || '';
                const screeningStatus = external_screening.status || '';

                // Validate and handle the dateAdded
                const validDateAdded = dateAdded && !isNaN(new Date(dateAdded).getTime()) ? new Date(dateAdded).toISOString() : null;

                // Check search query match (case-insensitive)
                const matchesSearch =
                    bloodGroupDescription.toLowerCase().includes(search) ||
                    volume.toLowerCase().includes(search) ||
                    (validDateAdded && validDateAdded.toLowerCase().includes(search)) ||
                    origin.toLowerCase().includes(search) ||
                    pintSerial.toLowerCase().includes(search) ||
                    screeningStatus.toLowerCase().includes(search);

                // Check dropdown filters (case-insensitive)
                const matchesBloodGroup =
                    !this.filters.bloodGroup ||
                    bloodGroupDescription.toLowerCase() === this.filters.bloodGroup.toLowerCase();
                const matchesDateRegistered =
                    !this.filters.dateRegistered || dateAdded.startsWith(this.filters.dateRegistered);
                
                const matchesStatus =
                    !this.filters.status || screeningStatus.toLowerCase() === this.filters.status.toLowerCase();

                return matchesSearch && matchesBloodGroup && matchesDateRegistered  && matchesStatus;
            });
        },
        showingText() {
            const start = (this.currentPage - 1) * this.perPage + 1;
            const end = start + this.filteredScreenings.length - 1;
            return `Showing ${start}-${end} of ${this.totalCount}`;
        }
    },

    watch: {
        filters: { deep: true, handler: 'getexternalunits' },
        searchQuery: 'getexternalunits'
    },

    methods: {

        applyFilters(filters) {
            this.filters = { ...this.filters, ...filters };
            this.currentPage = 1;
        },

        resetFilters() {
            this.filters = {
                bloodGroup: "",
                dateRegistered: '',
                donationProcess: '',
                status: "",
            };
            this.currentPage = 1;
        },

        async handleScreen(externalScreeningId) {
            this.isLoading[externalScreeningId] = true;
            try {
                await new Promise(resolve => setTimeout(resolve, 500));
            if (externalScreeningId) {
                this.$router.push({
                    name: 'NewExternalUnitScreening',
                    params: { external_screening_id: externalScreeningId }
                });
                console.log('id', externalScreeningId)
            } else {
                console.error('Invalid screening id');
            }
        } catch (error) {
                console.error(error);
                } finally {
                this.isLoading[externalScreeningId] = false; // Reset loading state
                }
        },


        async handleViewDetails(externalScreeningId) {
            this.isLoading[externalScreeningId] = true;
            try {
                await new Promise(resolve => setTimeout(resolve, 500));
                this.$router.push({
                    name: 'ExternalUnitDetailsPage',
                    params: { external_screening_id: externalScreeningId }
                }); 
                } catch (error) {
                console.error(error);
                } finally {
                this.isLoading[externalScreeningId] = false; // Reset loading state
                }
            },

        async handleApprove(externalScreeningId) {
            try {
                await api.confirmExternalScreening(externalScreeningId);
                await SweetAlertService.showSuccess('Success!', 'External blood unit approved successfully!');
                this.$router.go(0);
            } catch (error) {
                this.error = error.message || 'Failed to confirm screening';
            }
        },

        async handleDispose(externalScreeningId) {
            try {
                await api.disposeExternalScreening(externalScreeningId);
                await SweetAlertService.showSuccess('Success!', 'External blood Unit disposed successfully!');
                this.$router.go(0);
            } catch (error) {
                this.error = error.message || 'Failed to dispose screening';
            }
        },

       

        async getexternalunits() {
            this.loading = true;
            try {
                const queryParams = { ...this.filters, search_query: this.searchQuery, page: this.currentPage, per_page: this.perPage };
                const response = await api.getExtenalScreenings(queryParams);
                this.external_screenings = response.data || response;
                this.currentPage = response.current_page;
                this.totalPages = response.total_pages;
                if (this.currentPage === this.totalPages) {
                  this.totalCount = (this.totalPages - 1) * this.perPage + this.external_screenings.length;
                } else {
                  this.totalCount = this.totalPages * this.perPage;
                }
                console.log('data:', this.external_screenings);
            } catch (error) {
                this.error = error.message || 'Failed to fetch donations';
            } finally {
                this.loading = false;
            }
        },

        calculatePageRange() {
            const maxPagesToShow = 5;
            let startPage = Math.max(1, this.currentPage - Math.floor(maxPagesToShow / 2));
            let endPage = Math.min(this.totalPages, startPage + maxPagesToShow - 1);

            // Adjust start page if we're near the end
            if (endPage - startPage + 1 < maxPagesToShow) {
                startPage = Math.max(1, endPage - maxPagesToShow + 1);
            }

            return Array.from(
                { length: endPage - startPage + 1 },
                (_, i) => startPage + i
            );
        },

        goToPage(page) {
            if (page >= 1 && page <= this.totalPages) {
                this.currentPage = page;
                this.getexternalunits();
            }
        },
        async previousPage() {
            if (this.currentPage > 1) {
                this.currentPage--;
                await this.getexternalunits();
            }
        },
        async nextPage() {
            if (this.currentPage < this.totalPages) {
                this.currentPage++;
                await this.getexternalunits();
            }
        },

        calculateDaysRemaining(expiryDate) {
            const today = new Date();
            const expiry = new Date(expiryDate);
            const timeDiff = expiry - today;
            return Math.ceil(timeDiff / (1000 * 60 * 60 * 24));
        },

        allTestsConfirmed(donation) {
            const tests = [
                donation.screening_test?.hepatitis_b,
                donation.screening_test?.hepatitis_c,
                donation.screening_test?.hiv,
                donation.screening_test?.vdrl,
                donation.screening_test?.malaria,
                donation.screening_test?.blood_clot
            ];

            return tests.every(test => test !== null && test !== '');
        },

       

        checkForPendingDisposal(external_screening) {
            const tests = {
                hepatitis_b: external_screening.hepatitis_b,
                hepatitis_c: external_screening.hepatitis_c,
                hiv: external_screening.hiv,
                vdrl: external_screening.vdrl,
                malaria: external_screening.malaria,
                blood_clot: external_screening.blood_clot
            };

            // Check for blood_clot and vdrl custom values
            if (tests.blood_clot === "Yes" || tests.vdrl === "Reactive") {
                return true;
            }

            // Check if any other test is positive
            const otherTestResults = [
                tests.hepatitis_b,
                tests.hepatitis_c,
                tests.hiv,
                tests.malaria,
            ];

            return otherTestResults.includes("Positive");
        },

        getExtenalScreeningStatus(external_screening) {
            if (external_screening.external_screening_logs) {
                const logsWithConfirmedBy = external_screening.external_screening_logs.filter(log => log.confirmed_by?.user_id !== null);

                if (this.checkForPendingDisposal(external_screening) && logsWithConfirmedBy.length === 6 &&   this.allTestsConfirmed(external_screening) && external_screening.unit_product_id !== null && external_screening.blood_group_id !== null && external_screening.expiry_date !== null && external_screening.pint_serial !== null && external_screening.origin !== null && external_screening.approved_by === null) {
                    return 'Pending Disposal';
                }
                else if (logsWithConfirmedBy.length === 6 && external_screening.unit_product_id !== null && external_screening.blood_group_id && external_screening.expiry_date !== null && external_screening.pint_serial !== null && external_screening.origin !== null && this.allTestsConfirmed(external_screening) && external_screening.approved_by === null) {
                    return 'Pending Approval';
                } else {
                    return external_screening.status;
                }
            }
        },

        
    },
}
</script>


<style lang="css" scoped></style>